import React from 'react';

const Testimonials: React.FC = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="bg-yellow-100 text-yellow-700 px-4 py-2 rounded-full text-sm font-semibold inline-block mb-4">
            ⭐ Wat anderen zeggen
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            500+ studenten gingen je voor
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Lees wat onze gebruikers te zeggen hebben over WFT Study Buddy
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {/* Testimonial 1 */}
          <div className="bg-white rounded-xl p-6 shadow-lg">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold">
                SM
              </div>
              <div className="ml-3">
                <p className="font-semibold text-gray-900">Sophie M.</p>
                <p className="text-sm text-gray-500">WFT Schade Particulier</p>
              </div>
            </div>
            <div className="flex mb-3">
              <span className="text-yellow-400">⭐⭐⭐⭐⭐</span>
            </div>
            <p className="text-gray-700">
              "Dankzij de AI vraag generator heb ik <strong>in één keer mijn examen gehaald</strong>! De zwakke punten analyse hielp me precies te zien waar ik moest oefenen."
            </p>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-white rounded-xl p-6 shadow-lg">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-emerald-600 rounded-full flex items-center justify-center text-white font-bold">
                LV
              </div>
              <div className="ml-3">
                <p className="font-semibold text-gray-900">Lucas V.</p>
                <p className="text-sm text-gray-500">WFT Basis</p>
              </div>
            </div>
            <div className="flex mb-3">
              <span className="text-yellow-400">⭐⭐⭐⭐⭐</span>
            </div>
            <p className="text-gray-700">
              "Veel beter dan traditionele studieboeken! De AI vragen zijn <strong>actueel en realistisch</strong>. Premium is zijn geld dubbel en dwars waard."
            </p>
          </div>

          {/* Testimonial 3 */}
          <div className="bg-white rounded-xl p-6 shadow-lg">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-pink-500 to-rose-600 rounded-full flex items-center justify-center text-white font-bold">
                ED
              </div>
              <div className="ml-3">
                <p className="font-semibold text-gray-900">Emma D.</p>
                <p className="text-sm text-gray-500">WFT Schade Particulier</p>
              </div>
            </div>
            <div className="flex mb-3">
              <span className="text-yellow-400">⭐⭐⭐⭐⭐</span>
            </div>
            <p className="text-gray-700">
              "De <strong>voortgang tracking</strong> houdt me gemotiveerd. Ik zie precies waar ik sta en wat ik nog moet verbeteren. Super handig!"
            </p>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          <div>
            <div className="text-4xl font-bold text-gray-900 mb-2">500+</div>
            <div className="text-gray-600">Geslaagde studenten</div>
          </div>
       <div>
  <div className="text-4xl font-bold text-gray-900 mb-2">100%</div>
  <div className="text-gray-600">CDFD-conform</div>
</div>
          <div>
            <div className="text-4xl font-bold text-gray-900 mb-2">10K+</div>
            <div className="text-gray-600">Vragen geoefend</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-gray-900 mb-2">4.9/5</div>
            <div className="text-gray-600">Gemiddelde score</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;